// styles.ts
import styled from 'styled-components/native';
import FastImage from 'react-native-fast-image';
import { Dimensions, Image, Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {
  getBottomSpace,
  getStatusBarHeight,
  isIphoneX,
} from 'react-native-iphone-screen-helper';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome from 'react-native-vector-icons/FontAwesome';
import LinearGradient from 'react-native-linear-gradient';
import Animated from 'react-native-reanimated';
import { getDynamicPaddingTop } from '../Home/dynamicPaddingTop';

export const Background = styled.ImageBackground`
  flex: 1;
  height: 100%;
`;

export const Container = styled.View`
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const Content = styled.View`
  justify-content: center;
  flex: 1;
  align-items: center;
`;
//@ts-ignore
export const LogoWheel = styled(FastImage)`
  width: ${RFValue(120)}px;
  height: ${RFValue(70)}px;
`;

export const WheelContainer = styled.View`
  position: relative;
  width: ${RFValue(280)}px;
  height: ${RFValue(280)}px;
  justify-content: center;
  align-items: center;
`;
//@ts-ignore
export const StaticWheelImage = styled(Image)`
  position: absolute;
  width: ${RFValue(280)}px;
  height: ${RFValue(280)}px;
`;

export const BrightWheelImage = styled(
  //@ts-ignore
  Animated.createAnimatedComponent(Image),
)`
  position: absolute;
  z-index: 301;
  width: ${RFValue(285)}px;
  height: ${RFValue(285)}px;
  top: -${RFValue(9)}px;
`;

export const SpinningWheelImage = styled(
  //@ts-ignore
  Animated.createAnimatedComponent(Image),
)`
  width: ${RFValue(210)}px;
  height: ${RFValue(210)}px;
`;
//@ts-ignore
export const SpinningButton = styled(Image)`
  width: ${RFValue(80)}px;

  height: ${RFValue(80)}px;
`;

export const AwesomeButtonText = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  position: absolute;
`;

export const SpinButtonContainer = styled.View`
  position: absolute;
  z-index: 301;
`;

export const SpinButton = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.spin_button_backgrund};

  border-radius: ${RFValue(60)}px;
  height: ${RFValue(60)}px;

  border: 2px solid ${({theme}) => theme.colors.shape};

  width: ${RFValue(60)}px;
  align-items: center;
  justify-content: center;

  position: absolute;
  z-index: 301;
`;

export const SpinButtonText = styled.Text`
  font-size: ${RFValue(16)}px;
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.bold};
  text-transform: uppercase;
`;

//@ts-ignore
export const GirosContainer = styled(LinearGradient)`
  padding: ${RFValue(4)}px ${RFValue(16)}px;
  border-radius: ${RFValue(12)}px;
  justify-content: center;
  align-items: center;
  
`;
export const GirosText = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.shape};
  text-transform: uppercase;
  font-size: ${RFValue(18)}px;
  text-align: center;
`;

export const GirosTextLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(8)}px;
  text-transform: uppercase;
  color: ${({theme}) => theme.colors.shape};
  text-align: center;
`;


let spacing=  0
  const win = Dimensions.get('screen');
 if(win.width <= 360){
   spacing = RFValue(20)
 }else{
   spacing = RFValue(10)
 }

 const paddingTop =getDynamicPaddingTop({translucent: false});


export const Header = styled.View`
  padding: 0 24px;
  position: absolute;
  z-index: 301;
  align-items: center;
  flex-direction: row; 
  justify-content: space-between;
  margin-top: ${Platform.OS === "android" ? paddingTop + spacing : paddingTop}px;

  gap:${RFValue(8)}px;
  
`;
//@ts-ignore
export const CloseIconImage = styled(FastImage)`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
`;


export const CloseButton = styled.TouchableOpacity``;

export const CloseButtonIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.shape};
`;


export const HelpIconImage = styled(FastImage)`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
`;

export const HelpText = styled.Text`
  font-size: ${RFValue(10)}px;
    font-family: ${({theme}) => theme.fonts.bold};

    color: ${({theme}) => theme.colors.shape};
`;

export const HelpButton = styled.TouchableOpacity`
  
`;


export const HelpButtonIcon = styled(Feather)`
  font-size: ${RFValue(24)}px;
  color: ${({theme}) => theme.colors.shape};
`;

export const Footer = styled.View`
  padding: 0 24px;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: ${RFValue(12)}px;

  border-top-left-radius: ${RFValue(12)}px;
  border-top-right-radius: ${RFValue(12)}px;

  position: absolute;
  bottom: 0;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;

export const WheelTitlesContainer = styled.View`
  justify-content: center;
  align-items: center;
  margin-top: ${RFValue(12)}px;
  gap:${RFValue(4)}px;
  padding:0 24px;
`;
export const WheelTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(18)}px;
  text-align:center;
  color: ${({theme}) => theme.colors.shape};
`;
export const WheelSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  text-align:center;
  color: ${({theme}) => theme.colors.shape};
`;

export const ModalContainer = styled.View``;

export const ModalContent = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(20)}px;
  padding-bottom: ${RFValue(24)}px;
`;

export const CloseModalIconButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(12)}px;
  right: ${RFValue(12)}px;
  z-index: 2;
`;

export const CloseIconButton = styled.TouchableOpacity``;

export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.black};
`;

export const ModalHeader = styled.View`
  background-color: ${({theme}) => theme.colors.primary};
  padding: ${RFValue(24)}px;

  border-top-left-radius: ${RFValue(20)}px;
  border-top-right-radius: ${RFValue(20)}px;
`;
export const ModalHeadline = styled.Text`
  text-align: center;
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.shape};
  font-family: ${({theme}) => theme.fonts.bold};
`;
export const ModalBody = styled.View`
  padding: 0 ${RFValue(24)}px;
  margin-top: ${RFValue(16)}px;
`;
export const ModalTitle = styled.Text`
  text-align: center;
  font-size: ${RFValue(18)}px;
  color: #ffd700;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const ModalText = styled.Text`
  text-align: center;
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const ModalFooter = styled.View`
  padding: 0 ${RFValue(24)}px;
  margin-top: ${RFValue(16)}px;
`;

export const LockContainer = styled.View``;
export const LockIcon = styled(FontAwesome)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(22)}px;
`;
//@ts-ignore
export const CoinsExplosion = styled(FastImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
`;

// Coupon Styles
export const CouponContainer = styled.View`
  margin: ${RFValue(16)}px 0;
  align-items: center;
`;

export const CouponContent = styled.View`
  flex-direction: row;
  background-color: #2a2a2a;
  border-radius: ${RFValue(12)}px;
  overflow: hidden;
  position: relative;
  min-height: ${RFValue(80)}px;
  width: ${RFValue(280)}px;

  /* Semicircular notches on left and right sides */
  &::before {
    content: '';
    position: absolute;
    left: -${RFValue(8)}px;
    top: 50%;
    width: ${RFValue(16)}px;
    height: ${RFValue(16)}px;
    background-color: ${({theme}) => theme.colors.background};
    border-radius: ${RFValue(8)}px;
    transform: translateY(-50%);
  }

  &::after {
    content: '';
    position: absolute;
    right: -${RFValue(8)}px;
    top: 50%;
    width: ${RFValue(16)}px;
    height: ${RFValue(16)}px;
    background-color: ${({theme}) => theme.colors.background};
    border-radius: ${RFValue(8)}px;
    transform: translateY(-50%);
  }
`;

export const CouponLeftSide = styled.View`
  flex: 1;
  padding: ${RFValue(12)}px ${RFValue(16)}px;
  justify-content: center;
`;

export const CouponRightSide = styled.View`
  width: ${RFValue(100)}px;
  padding: ${RFValue(12)}px ${RFValue(8)}px;
  justify-content: center;
  align-items: center;
  background-color: #1a1a1a;
`;

export const CouponDiscount = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(20)}px;
  color: #ffffff;
  text-align: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const CouponMaxValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  color: #ffffff;
  text-align: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const CouponDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: #cccccc;
  text-align: center;
`;

export const CouponBrand = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(14)}px;
  color: #00ff88;
  text-align: center;
`;

export const CouponExpiry = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(9)}px;
  color: #999999;
  text-align: center;
`;
